import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: {
          base: '#309BFF',
          lighten1: '#309BFF',
          lighten2: '#309BFF'
        }
      }
    },
    options: {
      customProperties: true
    }
  },
  icon: {
    checkboxOn: 'mdi-checkbox-marked-circle'
  }
})
